// extracted by mini-css-extract-plugin
module.exports = {"sideDrawer":"side-drawer-module--side-drawer--36oVQ","logo":"side-drawer-module--logo--dWGK_","mainNav":"side-drawer-module--main-nav--PZq3w"};